"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApp = void 0;
const createApp = ({ httpClient, }) => ({ spec, }) => {
    const path = '/apps';
    const body = { spec };
    const url = `${path}`;
    return httpClient.post(url, body);
};
exports.createApp = createApp;
//# sourceMappingURL=create-app.js.map